import { ContactAccountConst } from './contact-account';

export const AccountConst = {
  Expansions: {
    accountTeamUserInfo: 'accountTeamUserInfo',
    teamUserInfo: 'teamUserInfo',
    parentAccountInfo: 'parentAccountInfo',
    // listener notifications
    accountCandidatesInfo: 'accountCandidatesInfo',
  },
  PreferredVideoClient: {
    zoom: 'Zoom',
  },
  Types: {
    Direct: 'Direct',
  },
  CandidateRelationships: {
    CurrentlyEngaged: 'CurrentlyEngaged',
    PreviouslyEngaged: 'PreviouslyEngaged',
    PreviouslyInterviewing: 'PreviouslyInterviewing',
    PreviouslySubmitted: 'PreviouslySubmitted',
    PreviouslyEmployed: 'PreviouslyEmployed',
  },
  // Attrs we want to show through AccountContactAccountAssociation
  ContactAccountOptOutAttrs: ContactAccountConst.optOutColumns,
} as const;
